import { create } from 'zustand';
import { AUTH_TOKEN, USER_DATA } from '../../../constants/localStorageKey';
import { UserInfoModel } from '../../../pages/user/models/user.model';

interface CheckAuthState {
  loading: boolean;
  loginUser: UserInfoModel | null;
}

interface CheckAuthAction {
  handleCheckAuthHomePage: () => void;
  handleCheckAuthLoginPage: () => void;
  getLoginUser: () => void;
}

const checkAuth = (set: (partial: Partial<CheckAuthState & CheckAuthAction>) => void) => ({
  loading: true,
  loginUser: null as UserInfoModel | null,

  handleCheckAuthHomePage: () => {
    const raw = localStorage.getItem(AUTH_TOKEN);
    if (!raw) {
      localStorage.clear();
      window.location.href = '/login';
      return;
    }
    set({ loading: false });
  },

  handleCheckAuthLoginPage: () => {
    try {
      const raw = localStorage.getItem(AUTH_TOKEN);
      if (!raw) {
        localStorage.clear();
      } else {
        window.location.href = '/';
      }
      set({ loading: false });
    } catch (error) {
      window.location.href = '/login';
    }
  },

  getLoginUser: () => {
    try {
      const raw = localStorage.getItem(USER_DATA);
      const parsed = raw ? JSON.parse(raw) : null;
      const loginUser: UserInfoModel | null = parsed?.userData ?? null;
      set({ loginUser, loading: false });
    } catch (error) {
      set({ loading: false });
    }
  },
});

const checkAuthController = create<CheckAuthState & CheckAuthAction>(checkAuth);

export default checkAuthController;
